module.exports = __webpack_public_path__ + "static/media/right.51f9b661.svg";